<template>
  <div class="wrap">
    <div class="title">
      <span>{{ editTitle }}</span>
    </div>
    <div class="content">
      <el-form
        ref="ruleForm"
        :rules="rules"
        label-width="100px"
        class="ruleForm"
        size="small"
      >
        <el-row>
          <el-col>
            <el-form-item>
              <div>
                <span>得分篇数上限配置</span>
                <el-input-number
                  placeholder="请输入上限值"
                  style="width:100px"
                  v-model="key1.value"
                  :key="key1.key"
                  required
                ></el-input-number>
              </div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col>
            <el-form-item>
              <div>
                <span>每篇文章学分</span>
                <el-input-number
                  placeholder="请输入学分值"
                  style="width:100px"
                  v-model="key2.value"
                  :key="key2.key"
                ></el-input-number>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item style="text-align: center;">
          <el-button @click="reset">重置</el-button>
          <el-button @click="$router.back()">返回</el-button>
          <el-button type="primary" @click="onSubmit">提交</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { creditRuleUpdate, creditRuleInfo } from "@/api/creditRule";

export default {
  name: "editRule",
  data() {
    let validateNumber = (rule, value, callback) => {
      let reg = /(^[0-9]*[1-9][0-9]*)$/;
      if (!value || !reg.test(value)) {
        callback();
      } else {
        callback("请输入正整数值");
      }
    };
    let validateSmallNumber = (rule, value, callback) => {
      let reg = /^\d*\.{0,1}\d{0,2}$/;
      if (!value || !reg.test(value)) {
        callback();
      } else {
        callback("请输入正确的分值");
      }
    };
    return {
      editTitle: "编辑学分规则",
      rules: {
        key1: {
          value: [
            { required: true, validator: validateNumber, trigger: "blur" }
          ]
        },
        key2: {
          value: [
            { required: true, validator: validateSmallNumber, trigger: "blur" }
          ]
        }
      },
      ruleForm: {
        creditRuleDetails: []
      },
      key1: {
        id: "",
        key: "1",
        value: ""
      },
      key2: {
        id: "",
        key: "2",
        value: ""
      },
      edituuid: "",
      resourceType: 2,
      deptId: "",
      showError: false
    };
  },
  created() {
    this.editTitle = "编辑学分规则";
    this.getDetail();
  },
  methods: {
    //获取数据
    getDetail: function() {
      this.edituuid = this.$route.query.id;
      creditRuleInfo(this.edituuid).then(res => {
        if (!res || res.code != 0) return;
        const { data } = res;
        const list = data.creditRuleDetails;
        if (list.length > 0) {
          let that = this;
          list.forEach(function(creditRuleDetail) {
            if (creditRuleDetail.ruleKey == that.key1.key) {
              that.key1.id = creditRuleDetail.uuid;
              that.key1.value = creditRuleDetail.ruleValue;
            } else if (creditRuleDetail.ruleKey == that.key2.key) {
              that.key2.id = creditRuleDetail.uuid;
              that.key2.value = creditRuleDetail.ruleValue;
            }
          });
        }
      });
    },
    //重置
    reset() {
      this.$confirm(`确认重置表单吗？`, "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$refs["coverUpload"].clearFiles();
          this.$refs["ruleForm"].resetFields();
        })
        .catch(() => {});
    },
    onSubmit() {
      if (this.key1.value != null) {
        let that = this;
        this.ruleForm.creditRuleDetails.push({
          uuid: that.key1.id,
          ruleId: that.edituuid,
          ruleKey: that.key1.key,
          ruleValue: that.key1.value
        });
      }
      if (this.key2.value != null) {
        let that = this;
        this.ruleForm.creditRuleDetails.push({
          uuid: that.key2.id,
          ruleId: that.edituuid,
          ruleKey: that.key2.key,
          ruleValue: that.key2.value
        });
      }
      this.$confirm(`确认提交吗？`, "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          /* this.ruleForm.uuid = this.edituuid;
                         this.ruleForm.resourceType = this.resourceType;
                         this.ruleForm.deptId = this.deptId;*/
          creditRuleUpdate(this.ruleForm).then(res => {
            if (!res || res.code != 0) throw new Error(res.msg);
            this.$message.success(res.msg);
            this.$router.back();
            this.$refs["ruleForm"].resetFields();
          });
        })
        .catch(() => {});
    },
    cancel() {
      this.$router.back();
      this.$refs["ruleForm"].resetFields();
    }
  }
};
</script>

<style lang="scss" scoped>
.wrap {
  background-color: #ffffff;
  height: 100%;

  .title {
    padding: 0 32px;
    height: 68px;
    line-height: 68px;
    color: #333333;
    font-weight: bold;
    font-size: 16px;
    border-bottom: 1px solid #e8e8e8;
    box-sizing: border-box;
  }

  .content {
    padding: 32px;

    /deep/ .el-form-item__label {
      font-size: 14px;
      color: #51627d;
    }
  }
}

.img_tip {
  font-size: 12px;
  color: #666;
}

$textColor: #51627d;
$textSize: 14px;
.avatar-uploader /deep/ .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  background-color: #f7f9fc;
  width: 104px;
  height: 104px;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 84px;
  height: 84px;
  line-height: 84px;
  text-align: center;
}

.avatar {
  width: 104px;
  height: 104px;
  display: block;
}

.upload-text {
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  color: $textColor;
  font-size: 13px;
}
</style>
